export const BookShipmentConfirmResidentialResultType = {
  AddResidentialToQuote: "AddResidentialToQuote",
  Continue: "Continue",
} as const;
export type BookShipmentConfirmResidentialResultType =
  (typeof BookShipmentConfirmResidentialResultType)[keyof typeof BookShipmentConfirmResidentialResultType];
